import type { LayoutLoad } from './$types';
import { getInitLocale, loadTranslations } from '$lib/translations';

// this is set false to force adapter-static to SPA mode
export const prerender = false;
export const ssr = false;

export const load: LayoutLoad = async ({ url }) => {
  const { pathname } = url;
  const initLocale = getInitLocale();
  await loadTranslations(initLocale, pathname);

  return { initLocale };
}
